import Dropzone from 'dropzone';

// Make sure Dropzone doesn't try to attach itself to the
// element automatically.
// This behaviour will change in future versions.
Dropzone.autoDiscover = false;

// see https://github.com/dropzone/dropzone/blob/main/src/options.js

if ($('#upload-form').length) {
  let myDropzone = new Dropzone('#upload-form', {
    paramName: 'images',  // The name that will be used to transfer the file
    acceptedFiles: 'image/*',
    maxFilesize: 10      // MB
  });

  myDropzone.on('addedfile', file => {
    console.log(`File added: ${file.name}`);
  });
}